import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

import { agentForm } from './agentForm';

export const listingAgentForm = {
  name: FormNames.LISTING_AGENT,
  label: 'Listing Agent',
  levelType: AutoLockFormsLevelType.FORM,
  children: agentForm.children,
};
